import { render, staticRenderFns } from "./DiviiLogo.vue?vue&type=template&id=7a7247ca&scoped=true"
import script from "./DiviiLogo.vue?vue&type=script&lang=js"
export * from "./DiviiLogo.vue?vue&type=script&lang=js"
import style0 from "./DiviiLogo.vue?vue&type=style&index=0&id=7a7247ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a7247ca",
  null
  
)

export default component.exports